import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import i18n from "../i18n";
import { sendError } from "../errors";
import { setLoading } from "../store";
import profileApi from "../api/profile";
import { createWorkExperienceHandling } from "../services/workExperiences";

import Alert from "./Alert.jsx";
import Avatar from "./Avatar.jsx";
import BackButton from "./BackButton.jsx";
import Button from "./Button.jsx";
import TalentDetails from "./TalentDetails.jsx";
import TalentShortView from "./TalentShortView.jsx";

export default function JobSearchSummary(props) {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(async () => {
    dispatch(setLoading(true));
    try {
      const response = await profileApi.me();
      // Don't show this if no job search is requested
      if (response.jobSearch) {
        setData(response);
      } else {
        props.onNext();
      }
    } catch (err) {
      setError("Could not load data.");
      sendError(err);
    }
    dispatch(setLoading(false));
  }, []);

  const { addOrUpdateExperience, deleteExperience } =
    createWorkExperienceHandling(data, setData);

  // Hide until everything is loaded or failed
  if (data || error) {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">{i18n.t("pages.common.summary")}</h1>

        <p class="t-body3 mt-0 mb-64 pb-48 task-page__bordered">
          {i18n.t("component.job_search_summary.description")}
        </p>

        {error && <Alert error>{error}</Alert>}

        {data && <Avatar class="mb-48" extraBig user={data} />}
        {data && <TalentShortView class="mb-48" user={data} />}

        {data && (
          <TalentDetails
            isSelf
            user={data}
            addOrUpdateExperience={addOrUpdateExperience}
            deleteExperience={deleteExperience}
          />
        )}

        <div class="task-page__buttons mt-64">
          {props.onBack && (
            <BackButton class="mr-2" noIndent onClick={props.onBack} />
          )}
          <Button onClick={props.onNext}>Submit application</Button>
        </div>
      </section>
    );
  }
  return <div></div>;
}
